import styled from "styled-components";
import { useContext, useEffect, useState } from "react";
import { serverLine } from "../../../../controllers/network/serverLine.js";
import LoggedInBoilerplate from "../LoggedInBoilerplate.js";
import LoadingSection from "../../../helperComponents/LoadingSection.js";
import { GoLocation } from "react-icons/go";
import { PiPerson } from "react-icons/pi";
import calculateAge from "../../../../controllers/calculateAge.js";
import CustomButton from "../../../helperComponents/CustomButton.js";
import { BiMapPin, BiPlus, BiUser } from "react-icons/bi";
import getSubPath from "../../../../controllers/getSubPath.js";
import getImageURL from "../../../../controllers/getImageURL.js";
import goTo from "../../../../controllers/goTo.js";
import { RiAlarmWarningLine, RiEdit2Line } from "react-icons/ri";
import { MdOutlineRadioButtonUnchecked } from "react-icons/md";
import { GrDocument } from "react-icons/gr";
import MapWithDraggableMarker2 from "../../../map/MapWithDraggableMarker2.js";
import CustomMasonry from "../../../helperComponents/CustomMasonry.js";
import EmployeeCard from "../employees/EmployeeCard.js";
import SiteDetailSection from "./SiteDetailSection.js";
import { TbSignature } from "react-icons/tb";
import Context from "../../../../Context.js";
import BubbleTextForPageHeader from "../../../customUiForCs/BubbleTextForPageHeader.js";
import IconWithTextForPageHeader from "../../../customUiForCs/IconWithTextForPageHeader.js";
import CustomLabel from "../../../customUiForCs/CustomLabel.js";
import NomenclatureOfEmployee from "../nomenclature/NomenclatureOfEmployee.js";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 300px;
  gap: 20px;
  margin-top: 50px;
  width: 100%;
  align-items: center;
`;

const Column1 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 70vw;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const Image = styled.img`
  object-fit: cover;
  width: 200px;
  border-radius: 15px;
  height: 200px;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  padding: 0 14px;
  margin-right: 10px;
`;

const Title = styled.div`
  font-size: 30px;
  font-weight: 900;
  color: var(--accent);
  text-transform: uppercase;
`;

const Desc = styled.div`
  font-size: 12px;
  text-transform: capitalize;
  color: var(--elementDim);
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-top: 10px;
  flex-wrap: wrap;
`;

const TopSection = styled.div`
  background: var(--surface2);
  border: 1px solid var(--border);
  border-radius: 15px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  overflow: hidden;
  width: 100%;

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 20px;
    align-items: flex-start;
    /* justify-content: center; */
    /* align-items: center; */
  }
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  gap: 15px;
`;

const PrimaryLine = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  @media (max-width: 900px) {
    flex-wrap: wrap;
  }
`;

const SecondaryLine = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;

  @media (max-width: 900px) {
    flex-wrap: wrap;
  }
`;

const MapContainer = styled.div`
  height: 100%;
  border-radius: 15px;
  overflow: hidden;
  width: 50%;
`;

const EmployeesSection = styled.div`
  background: var(--surface2);
  border: 1px solid var(--border);
  border-radius: 15px;
  padding: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const DetailsSection = styled.div`
  background: var(--surface2);
  border: 1px solid var(--border);
  border-radius: 15px;
  padding: 15px;
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SectionLabel = styled.div`
  font-size: 16px;
  opacity: 0.7;
  font-weight: 700;
  color: var(--elementDim);
`;

const SecondSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
  justify-content: space-between;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export default function SitePage({ onClick }) {
  const [item, setItem] = useState(null);
  const [itemID, setItemID] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let newItemID = getSubPath(1);
    setItemID(newItemID);
  }, []);

  useEffect(() => {
    if (itemID) loadItemToBeEdited();
  }, [itemID]);

  let core = null;

  let titleLine1 = null;
  let titleLine2 = null;

  if (loading) {
    titleLine1 = "Page de";
    titleLine2 = "Site";

    core = <LoadingSection />;
  } else {
    if (!item) return null;

    titleLine1 = "Page de";
    titleLine2 = item.placeName;

    core = (
      <Container>
        <Column1>
          <TopSection>
            <Image src={getImageURL(item.image)}></Image>

            <Right>
              <PrimaryLine>
                <Title>
                  {item.placeName}

                  {item.codename ? " - " + item.codename : null}
                </Title>

                <BubbleTextForPageHeader>
                  {item.isActive ? "Actif" : "Inactif"}
                </BubbleTextForPageHeader>
              </PrimaryLine>
              <SecondaryLine>
                <IconWithTextForPageHeader icon={<TbSignature />}>
                  {item.contracts
                    ? `${item.contracts.length} Contrats`
                    : "0 Contrats"}
                </IconWithTextForPageHeader>
                <IconWithTextForPageHeader icon={<RiAlarmWarningLine />}>
                  {item.assistance
                    ? `${item.assistance.length} Assistance`
                    : "0 Assistance"}
                </IconWithTextForPageHeader>
                <IconWithTextForPageHeader icon={<BiMapPin />}>
                  {item.zoneName ? item.zoneName : "Zone : Non"}
                </IconWithTextForPageHeader>
              </SecondaryLine>

              <Buttons>
                <CustomButton onClick={goTo(`/add-employee`)} icon={<BiUser />}>
                  Ajouter un agent
                </CustomButton>

                <CustomButton
                  onClick={goTo(`/edit-site/?itemID=${item._id}`)}
                  icon={<RiEdit2Line />}
                >
                  Modifier
                </CustomButton>
              </Buttons>
            </Right>
          </TopSection>

          <SecondSection>
            <SiteDetailSection item={item} />

            {item.latitude && item.longitude ? (
              <MapContainer>
                <MapWithDraggableMarker2
                  value={{ lat: item.latitude, lng: item.longitude }}
                  disableDrag={true}
                />
              </MapContainer>
            ) : null}
          </SecondSection>

          <NomenclatureOfEmployee
            initialSiteID={itemID}
            columns={2}
            disableSiteFilter={true}
            // nothingFoundMessage={
            //   "Aucun employé n’a encore été ajouté à ce site"
            // }
          />
        </Column1>
      </Container>
    );
  }

  return (
    <LoggedInBoilerplate
      showBackButton={true}
      titleLine1={titleLine1}
      titleLine2={titleLine2}
    >
      {core}
    </LoggedInBoilerplate>
  );

  async function loadItemToBeEdited() {
    setLoading(true);
    let data = await serverLine.get(`/site/?itemID=${itemID}`);
    setItem(data);
    setLoading(false);
  }
}

const IconWithTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  color: var(--elementDim);
`;

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 19px;
`;

const IconText = styled.div`
  font-size: 16px;
  font-weight: 600;
`;

function IconWithText({ icon, children }) {
  return (
    <IconWithTextContainer>
      <Icon>{icon}</Icon>
      <IconText>{children}</IconText>
    </IconWithTextContainer>
  );
}
